var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonquipement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.44922 2.3335H16.6666",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44922 7.6665H16.6666",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44922 13H16.6666",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H3.72463V3.66667H1V1Z",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6.3335H3.72463V9.00016H1V6.3335Z",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 11.6665H3.72463V14.3332H1V11.6665Z",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonquipement);
export default __webpack_public_path__ + "static/media/Mon équipement.caba2e0f8ea4526154787ae019c35920.svg";
export { ForwardRef as ReactComponent };